var _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e5e7eb",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M46.5 31.5h-.32a10.49 10.49 0 0 0-19.11-8 7 7 0 0 0-10.57 6 7.21 7.21 0 0 0 .1 1.14A7.5 7.5 0 0 0 18 45.5a4.19 4.19 0 0 0 .5 0h28a7 7 0 0 0 0-14z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d1d5db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M17 58h30"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "0s",
    dur: "5s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-4 0; 4 0; -4 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#d1d5db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M17 52h30"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-4s",
    dur: "5s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-4 0; 4 0; -4 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFog);
export default __webpack_public_path__ + "static/media/fog.2b84db7df769bde405260b32b6528883.svg";
export { ForwardRef as ReactComponent };